import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  // 老会员激活 ActivateMember
  {
    path: "/activate-member",
    name: "ActivateMember",
    component: () =>
      import(
        /* webpackChunkName: "ActivateMember" */ "../view/oldMember/ActivateMember.vue"
      ),
  },
  // 联系客服 ContactSupport
  {
    path: "/contact-support",
    name: "ContactSupport",
    component: () =>
      import(
        /* webpackChunkName: "ActivateMember" */ "../view/oldMember/ContactSupport.vue"
      ),
  },
  {
    path: "/skip-page",
    name: "SkipPage",
    component: () =>
      import(/* webpackChunkName: "SkipPage" */ "../view/SkipPage.vue"),
  },
  // 申请流程
  {
    path: "/apply-process",
    name: "ApplyProcess",
    component: () =>
      import(
        /* webpackChunkName: "ApplyProcess" */ "../view/process/ApplyProcess.vue"
      ),
  },
  // 等待审核
  {
    path: "/wait-audit",
    name: "WaitAudit",
    component: () =>
      import(
        /* webpackChunkName: "WaitAudit" */ "../view/process/WaitAudit.vue"
      ),
  },
  // 审核拒绝
  {
    path: "/audit-refuse",
    name: "AuditRefuse",
    component: () =>
      import(
        /* webpackChunkName: "AuditRefuse" */ "../view/process/AuditRefuse.vue"
      ),
  },
  // 待支付
  {
    path: "/to-pay",
    name: "ToPay",
    component: () =>
      import(/* webpackChunkName: "ToPay" */ "../view/process/ToPay.vue"),
  },
  // 预览证书
  {
    path: "/preview-cert",
    name: "PreviewCert",
    component: () =>
      import(
        /* webpackChunkName: "PreviewCert" */ "../view/process/PreviewCert.vue"
      ),
  },
  // 生成证书中
  {
    path: "/generate-cert",
    name: "GenerateCert",
    component: () =>
      import(
        /* webpackChunkName: "GenerateCert" */ "../view/process/GenerateCert.vue"
      ),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
